export default __webpack_public_path__ + "static/media/excelLogo.ee29f767.svg";